import React, {useEffect, useState} from 'react';
import '../ChestPurchaseModal/ChestPurchaseModal.css';
import './PremiumInfoModal.css';
import PageButton from '../../elements/PageButton/PageButton';
import PurchaseInterestRewardModal from '../PurchaseInterestRewardModal/PurchaseInterestRewardModal';
import {getPremiumImagePath} from '../../../utils/premium/getPremiumImagePath';
import {getFormattedPrice} from '../../../utils/price/getFormattedPrice';
import {WIN_POINTS_COLOR_LIGHT} from '../../../styles/constants';
import {PURCHASE_INTEREST_TYPES} from '../../../configs/purchaseInterestRewards';
import {RUBLE_SIGN} from '../../../constants/text';

const PAGE_ID = 'PremiumInfoModal';

/**
 * Модалка предмета-премиума в магазине: стилизована как модалка покупки
 * сундука (переиспользует ее классы). Внутри — описание преимуществ и цена в
 * рублях. Покупка пока не подключена: кнопка покупки открывает поверх модалку
 * раннего доступа с разовым подарком за интерес
 * (см. PurchaseInterestRewardModal).
 */
function PremiumInfoModal({premium, onClose}) {
  const [visible, setVisible] = useState(false);
  const [showInterestModal, setShowInterestModal] = useState(false);

  useEffect(() => {
    const showTimer = setTimeout(() => setVisible(true), 50);
    return () => clearTimeout(showTimer);
  }, []);

  const handleClose = () => {
    setVisible(false);
    setTimeout(() => {
      onClose?.();
    }, 300);
  };

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      handleClose();
    }
  };

  if (!premium) return null;

  return (
    <div
      className={`chest-purchase-overlay ${visible ? 'chest-purchase-overlay_visible' : ''}`}
      onClick={handleOverlayClick}
      role="dialog"
      aria-modal="true"
      style={{'--chest-shadow-color': WIN_POINTS_COLOR_LIGHT}}
    >
      <div className={`chest-purchase-modal ${visible ? 'chest-purchase-modal_visible' : ''}`}>
        <div className="chest-purchase-content">
          <div className="chest-purchase-image-wrapper">
            <img
              className="chest-purchase-image"
              src={getPremiumImagePath(premium.id)}
              alt={premium.name}
            />
          </div>

          <h2 className="chest-purchase-name text-coins">
            {premium.name}
          </h2>

          <div className="premium-info-benefits">
            <div className="premium-info-benefit">
              <img className="premium-info-benefit-icon" src="/img/icons/numens.png" alt="Награда"/>
              <span>
                <span className="premium-info-benefit-accent">х2 награда</span>
                <span className="premium-info-benefit-regular">за все матчи</span>
              </span>
            </div>
            <div className="premium-info-benefit">
              <img
                className="premium-info-benefit-icon premium-info-benefit-icon_league" src="/img/icons/league_gold.png"
                alt="Рейтинговый матч"
              />
              <span>
                <span className="premium-info-benefit-accent">х4 награда</span>
                <span className="premium-info-benefit-regular">за первый рейтинговый матч дня</span>
              </span>
            </div>
            <div className="premium-info-benefit">
              <span
                className="premium-info-benefit-icon premium-info-benefit-icon_chest"
                role="img"
                aria-label="Ежедневные награды"
              />
              <span>
                <span className="premium-info-benefit-accent">Улучшенные ежедневные награды</span>
                <span className="premium-info-benefit-regular">за вход</span>
              </span>
            </div>
            <div className="premium-info-benefit">
              <img className="premium-info-benefit-icon" src="/img/icons/coupon.png" alt="Скидка"/>
              <span>
                <span className="premium-info-benefit-accent">Дополнительная скидка 10%</span>
                <span className="premium-info-benefit-regular">на покупку сундуков за</span>
                <span className="premium-info-benefit-crystals">кристаллы</span>
              </span>
            </div>
            {premium.bonusCrystals > 0 && (
              <div className="premium-info-benefit">
                <img className="premium-info-benefit-icon" src="/img/icons/crystal.png" alt="Кристаллы"/>
                <span>
                  <span className="text-crystals">+{getFormattedPrice(premium.bonusCrystals)} кристаллов</span>
                  {' сразу при покупке'}
                </span>
              </div>
            )}
          </div>

          <div className="main-menu-buttons chest-purchase-buttons">
            <PageButton
              className="chest-purchase-buy-button"
              onClick={() => setShowInterestModal(true)}
              pageId={PAGE_ID}
              buttonId="buy"
            >
              Купить за {getFormattedPrice(premium.priceRub)} {RUBLE_SIGN}
            </PageButton>

            <PageButton
              className="main-menu-button_secondary"
              onClick={handleClose}
              pageId={PAGE_ID}
              buttonId="hide"
            >
              Скрыть
            </PageButton>
          </div>
        </div>
      </div>

      {showInterestModal && (
        <PurchaseInterestRewardModal
          type={PURCHASE_INTEREST_TYPES.PREMIUM}
          onClose={() => setShowInterestModal(false)}
        />
      )}
    </div>
  );
}

export default PremiumInfoModal;
